 <template>
  <el-form
    :model="form"
    class="search-form d-s-c d-r demo-form-inline"
    style="flex-wrap: wrap;"
    size="mini"
    label-width="80px"
  >
    <!-- 表单内容 -->
    <!-- <el-form-item label="案件ID">
      <el-input v-model="form.caseId" placeholder="请输入"></el-input>
    </el-form-item> -->
    <el-form-item label="订单编号">
      <el-input v-model="form.order_no" placeholder="请输入"></el-input>
    </el-form-item>
    <!-- <el-form-item label="逾期类型">
      <el-input v-model="form.overdueType" placeholder="请输入"></el-input>
    </el-form-item> -->
    <el-form-item label="关键字">
      <el-input v-model="form.search" placeholder="请输入用户名或手机号"></el-input>
    </el-form-item>

    <!-- <el-form-item label="手机号">
      <el-input v-model="form.phone" placeholder="请输入"></el-input>
    </el-form-item> -->
    <!-- <el-form-item label="逾期金额">
      <el-input v-model="form.overdueAmount" placeholder="请输入"></el-input>
    </el-form-item> -->
    <!-- <el-form-item label="逾期天数">
      <el-input v-model="form.overdueDays" placeholder="请输入"></el-input>
    </el-form-item> -->
    <!-- <el-form-item label="事件状态">
      <el-input v-model="form.eventStatus" placeholder="请输入"></el-input>
    </el-form-item> -->

    <!-- <el-form-item label="跟进人">
      <el-input v-model="form.followUser" placeholder="请输入"></el-input>
    </el-form-item> -->
    <!-- <el-form-item label="入催时间">
      <el-input v-model="form.followTime" placeholder="请输入"></el-input>
    </el-form-item> -->
    <el-form-item label-width="20px">
      <div class="d-s-c d-r">
        <el-button type="primary" @click="onSubmit">查询</el-button>
        <el-button @click="onReset">重置</el-button>
      </div>
    </el-form-item>
  </el-form>
</template>

<script>
const form = {
  // 案件ID 订单编号 逾期类型 用户姓名
  // 手机号 逾期金额 逾期天数 事件状态 跟进人 入催时间
  // caseId: "",
  // orderNo: "",
  // overdueType: "",
  // userName: "",

  // phone: "",
  // overdueAmount: "",
  // overdueDays: "",
  // eventStatus: "",

  // followUser: "",
  // followTime: ""
  order_no:"",
  search:""
};

const onSubmit = function() {
  this.$emit('update-parent', { order_no:this.form.order_no,search:this.form.search });  
}

const onReset = function() {
  console.log("reset!");
  this.form.order_no = "";
  this.form.search = "";
  this.$emit('update-parent', { order_no:'',search:'' });  
}

let options = {
  name: "Search",
  data() {
    return { form };
  },
  methods: {
    onSubmit,
    onReset
  },
  created() {}
};

export default options;
</script>

<style lang="scss" scoped>
.search-form {
  width: 100%;
  .el-form-item {
    min-width: 300px;
    width: calc((100% - 100px) / 4);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/collection/collection_cases/component/Search.vue